import { get } from 'lodash'
import { isObject } from '../../../utils'

export default {
  data() {
    return {}
  },
  computed: {
    fieldPropertiesMap() {
      return this.$get('fieldPropertiesMap')
    },
    field() {
      return this.$get('getFieldByName')(this.name)
    },
    value: {
      get() {
        return get(this.field, 'value')
      },
      set(payload) {
        if (isObject(payload)) {
          const { value, options } = payload
          this.$dispatch('updatePropByName', {
            name: this.name,
            prop: 'value',
            value,
            options,
            namespace: this.$storeNamespace,
          })
        } else {
          this.$dispatch('updatePropByName', {
            name: this.name,
            prop: 'value',
            value: payload,
            namespace: this.$storeNamespace,
          })
        }
      },
    },
    id() {
      return get(this.field, 'id')
    },
    placeholder() {
      return get(this.field, 'placeholder')
    },
    type() {
      return get(this.field, 'type')
    },
    multiple() {
      return ['multiselect', 'status'].includes(this.field.type) || this.field.multiple || this.field.taggable
    },
    taggable() {
      return get(this.field, 'taggable')
    },
    listExp() {
      return get(this.field, 'listExp')
    },
    autocomplete() {
      return get(this.field, 'autocomplete', false)
    },
    dropdownOnlyOne() {
      return get(this.field, 'dropdownOnlyOne', false)
    },
    filterExp() {
      return get(this.field, 'filterExp')
    },
    idForm() {
      return this.$get('mongoId')
    },
    relFormId() {
      return get(this.field, 'relFormId')
    },
    hidden: {
      get() {
        return get(this.field, 'hidden')
      },
      set(value) {
        this.$dispatch('updatePropByName', {
          name: this.name,
          prop: 'hidden',
          value,
          namespace: this.$storeNamespace,
        })
      },
    },
    readOnly: {
      get() {
        const readOnly = get(this.field, 'readOnly')
        return Boolean(readOnly)
      },
      set(value) {
        this.$dispatch('updatePropByName', {
          name: this.name,
          prop: 'readOnly',
          value,
          namespace: this.$storeNamespace,
        })
      },
    },
    list: {
      get() {
        return get(this.field, 'list', { options: [], completed: false })
      },
      set(value) {
        this.$dispatch('updatePropByName', {
          name: this.name,
          prop: 'list',
          value,
          namespace: this.$storeNamespace,
        })
      },
    },
    label: {
      get() {
        return get(this.field, 'label')
      },
      set(value) {
        this.$dispatch('updatePropByName', {
          name: this.name,
          prop: 'label',
          value,
          namespace: this.$storeNamespace,
        })
      },
    },
    required: {
      get() {
        return get(this.field, 'validations.required', false)
      },
      set(value) {
        this.$dispatch('updatePropByName', {
          name: this.name,
          prop: 'required',
          value,
          namespace: this.$storeNamespace,
        })
      },
    },
    validations: {
      get() {
        return get(this.field, 'validations')
      },
      set(value) {
        this.$dispatch('updatePropByName', {
          path: this.path,
          prop: 'validations',
          value,
        })
      },
    },
    directInputEntry() {
      return get(this.field, 'directInputEntry')
    },
    formats() {
      return get(this.field, 'formats')
    },
    isSavable() {
      return this.$get('isSavable')
    },
  },
}
